import { type JsonDataItem } from '@g2u/ui-kit';
import env from 'env';

type BaseQueryOption = {
  type?: 'GET' | 'POST' | 'PUT';
  body?: JsonDataItem;
};

export const baseQuery = async (url: string, options?: BaseQueryOption) => {
  const response = await fetch(`${env.API_SERVER}${url}`, {
    method: `${options?.type ?? 'GET'}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(options?.body),
  });

  if (!response.ok) throw await response.json();
  const data = await response.json();
  return data;
};
